// import React from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   useTheme,
//   alpha,
//   Chip,
//   Breadcrumbs,
//   Link as MuiLink,
//   Grid,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";

// const SupportLayout = ({ 
//   title, 
//   category, 
//   subtitle, 
//   children, 
//   breadcrumbs = [],
//   stats = []
// }) => {
//   const theme = useTheme();

//   return (
//     <Box>
//       {/* Hero Section - FULL WIDTH with Enhanced Fade Effect */}
//       <Box
//         sx={{
//           position: "relative",
//           background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
//           color: "white",
//           pt: { xs: 10, md: 12 }, // More padding to ensure no menu overlap
//           pb: { xs: 10, md: 14 },
//           overflow: "hidden",
//           "&::before": {
//             content: '""',
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
//             opacity: 0.1,
//           },
//         }}
//       >
//         {/* Fade Effect Overlay - Bottom Fade */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             right: 0,
//             height: "40%",
//             background: `linear-gradient(to bottom, transparent 0%, ${alpha(theme.palette.background.default, 0.3)} 50%, ${theme.palette.background.default} 100%)`,
//             pointerEvents: "none",
//             zIndex: 1,
//           }}
//         />
        
//         {/* Subtle Top Fade (optional) */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             height: "20%",
//             background: `linear-gradient(to bottom, ${alpha(theme.palette.primary.dark, 0.8)} 0%, transparent 100%)`,
//             pointerEvents: "none",
//             zIndex: 1,
//           }}
//         />
        
//         <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2 }}>
//           {/* Breadcrumbs */}
//           {breadcrumbs.length > 0 && (
//             <Breadcrumbs
//               separator={<NavigateNextIcon fontSize="small" sx={{ color: "rgba(255,255,255,0.5)" }} />}
//               sx={{ mb: 3, color: "rgba(255,255,255,0.7)" }}
//             >
//               <MuiLink component={Link} to="/" sx={{ color: "inherit", textDecoration: "none", "&:hover": { color: "white" } }}>
//                 Home
//               </MuiLink>
//               {breadcrumbs.map((crumb, index) => (
//                 crumb.link ? (
//                   <MuiLink
//                     key={index}
//                     component={Link}
//                     to={crumb.link}
//                     sx={{ color: "inherit", textDecoration: "none", "&:hover": { color: "white" } }}
//                   >
//                     {crumb.label}
//                   </MuiLink>
//                 ) : (
//                   <Typography key={index} sx={{ color: "white" }}>
//                     {crumb.label}
//                   </Typography>
//                 )
//               ))}
//             </Breadcrumbs>
//           )}

//           {/* Category Chip */}
//           <Chip
//             label={category}
//             sx={{
//               mb: 2,
//               background: alpha(theme.palette.common.white, 0.2),
//               color: "white",
//               fontWeight: 600,
//               fontSize: "0.85rem",
//               backdropFilter: "blur(10px)",
//               "&:hover": { background: alpha(theme.palette.common.white, 0.3) }
//             }}
//           />

//           {/* Title */}
//           <Typography
//             variant="h1"
//             sx={{
//               fontSize: { xs: "2rem", md: "3rem", lg: "3.5rem" },
//               fontWeight: 800,
//               mb: 2,
//               lineHeight: 1.2,
//             }}
//           >
//             {title}
//           </Typography>

//           {/* Subtitle */}
//           <Typography
//             variant="h5"
//             sx={{
//               fontSize: { xs: "1rem", md: "1.2rem", lg: "1.3rem" },
//               opacity: 0.95,
//               maxWidth: "800px",
//               lineHeight: 1.5,
//               mb: stats.length > 0 ? 4 : 0,
//             }}
//           >
//             {subtitle}
//           </Typography>

//           {/* Stats */}
//           {stats.length > 0 && (
//             <Grid container spacing={3} sx={{ mt: 2 }}>
//               {stats.map((stat, index) => (
//                 <Grid item xs={6} md={3} key={index}>
//                   <Box
//                     sx={{
//                       background: alpha(theme.palette.common.white, 0.1),
//                       backdropFilter: "blur(10px)",
//                       borderRadius: 2,
//                       p: 2,
//                       transition: "transform 0.2s",
//                       "&:hover": {
//                         transform: "translateY(-4px)",
//                         background: alpha(theme.palette.common.white, 0.15),
//                       },
//                     }}
//                   >
//                     <Typography variant="h3" sx={{ fontWeight: 800, mb: 0.5, fontSize: { xs: "1.5rem", md: "2rem" } }}>
//                       {stat.value}
//                     </Typography>
//                     <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                       {stat.label}
//                     </Typography>
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           )}
//         </Container>
//       </Box>

//       {/* Main Content */}
//       <Container maxWidth="lg" sx={{ py: 6 }}>
//         {children}
//       </Container>
//     </Box>
//   );
// };

// export default SupportLayout;






import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Chip,
  Breadcrumbs,
  Link as MuiLink,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const SupportLayout = ({ 
  title, 
  category, 
  subtitle, 
  children, 
  breadcrumbs = [],
  stats = []
}) => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          color: "white",
          pt: { xs: 10, md: 12 },
          pb: { xs: 10, md: 14 },
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            opacity: 0.1,
          },
        }}
      >
        <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2 }}>
          {/* Breadcrumbs */}
          {breadcrumbs.length > 0 && (
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" sx={{ color: "rgba(255,255,255,0.5)" }} />}
              sx={{ mb: 3, color: "rgba(255,255,255,0.7)" }}
            >
              <MuiLink component={Link} to="/" sx={{ color: "inherit", textDecoration: "none", "&:hover": { color: "white" } }}>
                Home
              </MuiLink>
              {breadcrumbs.map((crumb, index) => (
                crumb.link ? (
                  <MuiLink
                    key={index}
                    component={Link}
                    to={crumb.link}
                    sx={{ color: "inherit", textDecoration: "none", "&:hover": { color: "white" } }}
                  >
                    {crumb.label}
                  </MuiLink>
                ) : (
                  <Typography key={index} sx={{ color: "white" }}>
                    {crumb.label}
                  </Typography>
                )
              ))}
            </Breadcrumbs>
          )}

          {/* Category Chip */}
          <Chip
            label={category}
            sx={{
              mb: 2,
              background: alpha(theme.palette.common.white, 0.2),
              color: "white",
              fontWeight: 600,
              fontSize: "0.85rem",
              backdropFilter: "blur(10px)",
              "&:hover": { background: alpha(theme.palette.common.white, 0.3) }
            }}
          />

          {/* Title */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2rem", md: "3rem", lg: "3.5rem" },
              fontWeight: 800,
              mb: 2,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: "1rem", md: "1.2rem", lg: "1.3rem" },
              opacity: 0.95,
              maxWidth: "800px",
              lineHeight: 1.5,
              mb: stats.length > 0 ? 4 : 0,
            }}
          >
            {subtitle}
          </Typography>

          {/* Stats */}
          {stats.length > 0 && (
            <Grid container spacing={3} sx={{ mt: 2 }}>
              {stats.map((stat, index) => (
                <Grid item xs={6} md={3} key={index}>
                  <Box
                    sx={{
                      background: alpha(theme.palette.common.white, 0.1),
                      backdropFilter: "blur(10px)",
                      borderRadius: 2,
                      p: 2,
                      transition: "transform 0.2s",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        background: alpha(theme.palette.common.white, 0.15),
                      },
                    }}
                  >
                    <Typography variant="h3" sx={{ fontWeight: 800, mb: 0.5, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                      {stat.value}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </Container>

        {/* ========== WAVE - STRAIGHT ON LEFT, CURVES ON RIGHT ========== */}
        <Box
          sx={{
            position: "absolute",
            bottom: -1,
            left: 0,
            right: 0,
            lineHeight: 0,
            zIndex: 10,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 100"
            preserveAspectRatio="none"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          >
            <path
              fill="white"
              fillOpacity="1"
              d="M0,0 L0,100 L1440,100 L1440,80 C1344,80 1248,70 1152,65 C1056,60 960,70 864,80 C768,90 672,95 576,90 C480,85 384,70 288,65 C192,60 96,70 48,75 L0,80 Z"
            />
          </svg>
        </Box>
      </Box>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        {children}
      </Container>
    </Box>
  );
};

export default SupportLayout;